"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const recoil_1 = require("recoil");
const storyCreateStates_1 = require("./storyCreateStates");
const react_i18next_1 = require("react-i18next");
const svgs_1 = require("@@/assets/svgs");
const IconButton_1 = __importDefault(require("@mui/material/IconButton"));
const styled_1 = __importDefault(require("@emotion/styled"));
function default_1() {
    const { t } = (0, react_i18next_1.useTranslation)();
    const titleRef = (0, react_1.useRef)(null);
    const [{ title }, setStoryData] = (0, recoil_1.useRecoilState)(storyCreateStates_1.storyDataState);
    return ((0, jsx_runtime_1.jsxs)(TitleInputWrapper, { children: [(0, jsx_runtime_1.jsxs)("span", Object.assign({ id: "title" }, { children: [t('스토리 제목'), (0, jsx_runtime_1.jsx)("span", Object.assign({ id: "asterisk" }, { children: "*" }))] })), (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("input", { ref: titleRef, value: title, maxLength: 40, placeholder: t('제목을 입력해 주세요'), onBlur: e => {
                            const trimmed = e.target.value.trim();
                            if (!trimmed) {
                                setStoryData(prev => (Object.assign(Object.assign({}, prev), { title: '' })));
                            }
                        }, onChange: e => {
                            setStoryData(prev => (Object.assign(Object.assign({}, prev), { title: e.target.value })));
                        } }), Boolean(title === null || title === void 0 ? void 0 : title.length) && ((0, jsx_runtime_1.jsx)(IconButton_1.default, Object.assign({ onClick: () => {
                            var _a;
                            setStoryData(prev => (Object.assign(Object.assign({}, prev), { title: '' })));
                            (_a = titleRef === null || titleRef === void 0 ? void 0 : titleRef.current) === null || _a === void 0 ? void 0 : _a.focus();
                        } }, { children: (0, jsx_runtime_1.jsx)(svgs_1.XCircleGraySvg, { css: { width: '16px', height: '16px' } }) })))] })] }));
}
exports.default = default_1;
const TitleInputWrapper = styled_1.default.div `
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 16px;
  margin-bottom: 10px;
  background-color: white;
  #title {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    font-weight: 700;
    font-size: 17px;
  }
  #asterisk {
    margin-left: 2px;
    color: red;
    font-weight: normal;
  }
  div {
    display: flex;
    align-items: center;
    input {
      width: 100%;
      padding: 10px 12px;
      border: 1px solid rgba(0, 0, 0, 0.1);
      border-radius: 4px;
      font-size: 16px;
      line-height: 20px;
    }
    .MuiIconButton-root {
      position: absolute;
      right: 25px;
    }
  }
`;
